import type { MouseEventHandler } from 'react'

const NextButton = (params: { onClick?: MouseEventHandler<HTMLButtonElement> } | undefined) => {
  return (
    <button className='button-pagination' onClick={params?.onClick}>
      <svg
        width='10'
        height='16'
        viewBox='0 0 10 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M10 7.99934L1.81794 16L1.22592e-06 14.2223L6.36412 7.99934L0 1.77763L1.81794 0L10 7.99934Z'
          fill='#0076E3'
        />
      </svg>
    </button>
  )
}

export default NextButton
